import { Box, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import { fetchAllAccounts, unlinkCalendar } from '../../../../../../store/slices/calendarSlice';
import zeplinColor from '../../../../../../theme/Color';
import CustomCard from '../../../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../../../shared/CustomModal/CustomModal';

const CalendarDisconnect = ({
  handleClose,
  isModalOpen,
  calendarProvider,
  calendarDetails,
}: {
  handleClose: () => void;
  isModalOpen: boolean;
  calendarProvider: string;
  calendarDetails: any;
}) => {
  const dispatch = useAppDispatch();

  const { unlinkLoading } = useAppSelector((state) => state.calendar);
  const isLoading = unlinkLoading;

  const onConfirmUnlink = async () => {
    try {
      await dispatch(
        unlinkCalendar({ provider: calendarDetails?.type, email: calendarDetails?.title }),
      ).unwrap();
      dispatch(fetchAllAccounts());
      handleClose();
    } catch (error) {
      console.error('Failed to unlink:', error);
    }
  };

  return (
    <>
      <CustomModal handleClose={handleClose} open={isModalOpen}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '20px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,

              width: '375px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '22px', xl: '32px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Disconnect Calendar?
                </Typography>
                <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                  {`Are you sure you want to disconnect your ${calendarProvider} calendar? You won’t be able to sync or view events until you reconnect.`}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Box
                  onClick={handleClose}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={isLoading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => onConfirmUnlink()}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: isLoading ? zeplinColor.Neutral4 : zeplinColor.Error,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={isLoading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={isLoading ? zeplinColor.BasicBlack : zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      {isLoading ? 'Disconnecting...' : 'Disconnect'}
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
    </>
  );
};

export default CalendarDisconnect;
